import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { MainLayout } from "../../layout/MainLayout";
import { HowToContainer, HowToFrame, LoaderOverlay } from "./HowToPage.styles";

export const HowToPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <MainLayout title="How To">
      <HowToContainer>
        {isLoading && (
          <LoaderOverlay>
            <CircularProgress />
          </LoaderOverlay>
        )}
        <HowToFrame
          title="RoomSync FAQ & How-Tos"
          src="https://scribehow.com/page-embed/RoomSync_FAQHow-Tos__cO5l4fF_QYWhkKx925lbrQ"
          allow="fullscreen"
          $isLoading={isLoading}
          onLoad={() => setIsLoading(false)}
        />
      </HowToContainer>
    </MainLayout>
  );
};

export const HOW_TO_PAGE_URL = "/how-to";
